import {CustomerInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class CustomerInfoModel {
  public currencyCode: string;

  constructor(params: CustomerInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string) {
    return new CustomerInfoModel({
      currencyCode,
    });
  }

  public static fromCartV2(customerInfo: CustomerInfo): CustomerInfoModel {
    return new CustomerInfoModel({
      currencyCode: customerInfo?.currencyCode,
    });
  }
}
